import { pino } from 'pino';

const instance = pino({
  name: 'data-collection',
  level: 'debug',

  browser: {
    asObject: true,
    serialize: true,
  },
});

export const createAppLogger = (appName: string, context?: unknown) =>
  instance.child({ appName, ...(context as any) });

export const createModuleLogger = (
  appLogger: Logger,
  moduleName: string,
  context?: unknown,
) => appLogger.child({ moduleName, ...(context as any) });

export type Logger = ReturnType<typeof createAppLogger>;
